import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import TaggedTopicInfo from './TaggedTopicInfo';

const useStyles = makeStyles(() => ({
  popover: {
    marginTop: 36,
    zIndex: 998,
    width: '100%',
    transform: props =>
      !props.position && `translate3d(0, ${props.offsetTop}px, 0) !important`,
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    background: '#FFFFFF',
    overflowY: 'auto',
    overflowX: 'scroll',
    width: '100%',
    padding: '0 18px 18px 18px',
    borderBottom: '1px solid #E3E3E3',
  },
}));

function MobileTaggedTopicsOverlay({ anchorEl, data, offsetTop, position }) {
  const classes = useStyles({ offsetTop, position });

  return (
    <Popper
      open
      anchorEl={anchorEl}
      className={classes.popover}
      placement="bottom"
      modifiers={{
        flip: {
          enabled: false,
        },
        preventOverflow: {
          enabled: true,
          boundariesElement: 'window',
        },
      }}
      transition
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={400}>
          <div className={classes.paper}>
            {data.map((el, index) => (
              <TaggedTopicInfo data={el} key={_get(el, 'fields.slug', index)} />
            ))}
          </div>
        </Fade>
      )}
    </Popper>
  );
}

MobileTaggedTopicsOverlay.propTypes = {
  anchorEl: PropTypes.element,
  data: PropTypes.array,
  offsetTop: PropTypes.number,
  position: PropTypes.string,
};

MobileTaggedTopicsOverlay.defaultProps = {
  position: null,
};

export default MobileTaggedTopicsOverlay;
